import { Field } from "./Field";

export const StepPersonal = ({ form, update }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
    <Field
      label="Artist / Stage Name *"
      testid="input-artist-name"
      placeholder="e.g. NOVA"
      value={form.artistName}
      onChange={(e) => update("artistName", e.target.value)}
    />
    <Field
      label="Full Legal Name *"
      testid="input-full-legal-name"
      placeholder="As it appears on legal documents"
      value={form.personal.fullLegalName}
      onChange={(e) => update("personal.fullLegalName", e.target.value)}
    />
    <Field
      label="Company / Entity Name"
      testid="input-company-name"
      placeholder="LLC, Inc, etc."
      value={form.personal.companyName}
      onChange={(e) => update("personal.companyName", e.target.value)}
    />
    <Field
      label="Date of Birth"
      testid="input-dob"
      type="date"
      value={form.personal.dob}
      onChange={(e) => update("personal.dob", e.target.value)}
    />
    <Field
      label="EIN Number"
      testid="input-ein"
      placeholder="XX-XXXXXXX"
      value={form.personal.ein}
      onChange={(e) => update("personal.ein", e.target.value)}
    />
    <Field
      label="Social Security Number"
      testid="input-ssn"
      placeholder="XXX-XX-XXXX"
      value={form.personal.ssn}
      onChange={(e) => update("personal.ssn", e.target.value)}
      hint="Stored securely. Visible to Xyion HQ only."
    />
    <Field
      label="Mailing Address"
      testid="input-mailing-address"
      multiline
      className="md:col-span-2"
      placeholder="Street, City, State, ZIP"
      value={form.personal.mailingAddress}
      onChange={(e) => update("personal.mailingAddress", e.target.value)}
    />
    <Field
      label="Diet Restrictions"
      testid="input-diet-restrictions"
      placeholder="Vegan, halal, none..."
      value={form.personal.dietRestrictions}
      onChange={(e) => update("personal.dietRestrictions", e.target.value)}
    />
    <Field
      label="Known Allergies"
      testid="input-allergies"
      placeholder="Peanuts, shellfish, none..."
      value={form.personal.allergies}
      onChange={(e) => update("personal.allergies", e.target.value)}
    />
    <div className="md:col-span-2 mt-2">
      <p className="xy-eyebrow mb-4">Emergency Contact</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <Field
          label="Name"
          testid="input-emergency-name"
          value={form.personal.emergencyName}
          onChange={(e) => update("personal.emergencyName", e.target.value)}
        />
        <Field
          label="Phone"
          testid="input-emergency-phone"
          type="tel"
          value={form.personal.emergencyPhone}
          onChange={(e) => update("personal.emergencyPhone", e.target.value)}
        />
        <Field
          label="Address"
          testid="input-emergency-address"
          value={form.personal.emergencyAddress}
          onChange={(e) => update("personal.emergencyAddress", e.target.value)}
        />
      </div>
    </div>
  </div>
);
